import React from 'react';
import Head from 'next/head';
import { FormattedMessage } from 'react-intl';

import { Description, JobInReviewContainer, Title } from './JobInReview.sc';

const Strong = (...chunks: React.ReactNode[]) => <strong>{chunks}</strong>;

const JobInReview = ({
  jobTitle,
  companyName,
}: {
  jobTitle: string;
  companyName: string;
}) => (
  <>
    <Head>
      <title>{jobTitle} - In Review</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <JobInReviewContainer
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <img src="./images/job-in-review.png" alt="Job In Review" />
      <FormattedMessage
        id="job.in.review_page.title"
        defaultMessage="Applying to this job is not {br} allowed yet."
        tagName={Title}
        values={{ br: <br /> }}
      />
      <FormattedMessage
        id="job.in.review_page.description"
        defaultMessage="Sorry, you are not able to apply to {br} <Strong>{jobTitle}</Strong> for <Strong>{companyName}</Strong> {br} because it's still under review by our team."
        tagName={Description}
        values={{ br: <br />, jobTitle, companyName, Strong }}
      />
    </JobInReviewContainer>
  </>
);

export default JobInReview;
